import { writable } from 'svelte/store';

export const newsData = writable([]);